import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification warning"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Warning:"),
  /*#__PURE__*/_createTextVNode(" Track copyright infringement validation is now being overridden by Admin.")
], -1)

import { computed } from 'vue'
import { useUserStore } from '@/store/user'
import { getCookie } from '@/helpers/cookie'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonateNotification',
  setup(__props) {

const JWT_TOKEN = process.env.VUE_APP_JWT_TOKEN
const userStore = useUserStore()
const email = computed(() => userStore.user.email)
const dashboardUrl = computed(() => process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com')
const isImpersonateMode = computed(() => getCookie(`DittoMusic[${JWT_TOKEN}Customer]`) !== null)

return (_ctx: any,_cache: any) => {
  return (isImpersonateMode.value && email.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, [
            _createTextVNode("You are currently logged in as - (" + _toDisplayString(email.value) + "), please ", 1),
            _createElementVNode("a", {
              href: `${dashboardUrl.value}/admin/users/remove_session`
            }, "click here", 8, _hoisted_2),
            _createTextVNode(" to return to normal.")
          ])
        ]),
        _hoisted_3
      ]))
    : _createCommentVNode("", true)
}
}

})